<template>
  <div class="ro-login account-box">
    <div class="ro-login-title">
      {{ isOpenAccount ? '請登入游戲角色賬號' : letter.selectLoginType }}
    </div>
    <template v-if="isOpenAccount">
    <label class="input-box box" :class="{ err: userAccountTips }">
      <span class="label">{{ letter.accountLabel }}：</span>
      <input
        v-model="userAccount"
        class="input"
        type="text"
        :class="{ err: userAccountTips }"
        @blur="judgeUserAccount()"
        :placeholder="letter.accountName"
      />
    </label>
    <p class="tips j-username-tip" v-if="userAccountTips">
      {{ userAccountTips }}
    </p>
    <label
      class="input-box password-box box"
      :class="{ err: userPasswordTips }"
    >
      <span class="label">{{ letter.passwordLabel }}：</span>
      <input
        v-model="userPassword"
        class="input"
        type="password"
        :class="[userPasswordTips ? 'err' : false, $platformClass]"
        @blur="judgeUserPassword()"
        :placeholder="letter.password"
      />
    </label>
    <p class="tips j-password-tip" v-if="userPasswordTips">
      {{ userPasswordTips }}
    </p>
    <div class="remember box">
      <div>
        <i class="goukuang j-remember-me" @click="toggleRemember">
          <i class="gou" v-show="isRemember"></i>
        </i>
        <span class="text j-remember-me" @click="toggleRemember">
          {{ letter.remember }}
        </span>
      </div>

      <a
        :href="findPwd"
        target="_blank"
        class="forget j-forget-pwd"
        v-if="!musVn"
      >
        {{ letter.forgetPwd }}
      </a>
    </div>
    <div class="btn-wrap">
      <a
        href="javascript:void(0);"
        class="btn login-btn j-login-btn"
        pointClass="j-login-btn"
        :loading="loading"
        @click="login"
      >
        <span>{{ letter.login }}</span>
        <i v-show="loading" class="loading light" style="margin-left: 1vh"></i>
      </a>
      <p class="tips j-request-tip request-tip">{{ loginRequestTips }}</p>
    </div>
    </template>
    <div class="other-login">
      <div
        v-for="(item, index) in thirdList"
        :key="index"
        class="third-box j-third-part-login"
      >
        <a
          class="login-type"
          href="javascript:;"
          :class="`j-${item}-login-btn ${$platformClass}`"
          @click="loginHrefJump(loginHref[item], false)"
        >
          <i :class="item"></i>
          <p class="name">{{ channelName[item] }}</p>
        </a>
      </div>
    </div>
    <button class="account-info j-account-info" @click="showPopup">
      沒有我的登錄方式？
    </button>
  </div>
</template>

<script type="text/javascript">
import { CHANNEL_NAME } from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import globalConfig from '../../utiles/globalConfig.js';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'accountLoginPage',
  data() {
    return {
      isOpenAccount: globalConfig.getHrefParam('isOpenAccount') === '1',
      channelName: CHANNEL_NAME,
      showThirdPart: globalConfig.getHrefParam('noThridPart') !== '1'
    };
  },
  computed: {
    findPwd() {
      let gameId =
        this.$store.state.gameId || globalConfig.getHrefParamUndecode('gameId');
      return getGlobalGetGotoLink({
        link: `https://pay.${mainHost}/platform/passport.html?gameId=${gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`
      });
    },
    letter() {
      return this.$store.state.letter;
    }
  },
  mixins: [login],
  methods: {
    loginHrefJump(href, target) {
      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'openThirdLoginLink',
            url: href
          },
          '*'
        );
      } else {
        window.open(href, target ? '_blank' : '_self');
      }
    },
    showPopup() {
      this.$emit('showPopup', {
        title: '提示',
        content:
          '如您已經有了遊戲帳號，但未綁定Facebook、Google等登錄方式，需要先與遊戲帳號關聯：\n方法1：在web登入頁面選擇Facebook/Google等登入方式，登入後輸入與遊戲相同的賬密進行綁定；\n方法2：前往遊戲登錄完成Facebook/Google登入綁定；',
        contentStyle: 'text-align: left;font-size: 1.7vh;'
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
